// extracted by mini-css-extract-plugin
export default {"searchBar":"MultiList_searchBar__u0eNg"};